import React from "react";
import _ from "lodash";
import styled from "styled-components";

import customTheme from "app/style/theme";

import { Box } from "grommet";

import Book from "app/api/book";
import LayoutEngine from "app/api/layoutEngine";
/*OEF ToC/SECTION MODs*/
const layoutEngine = new LayoutEngine(generateLayoutEngine());

function generateLayoutEngine() {
  const elements = {};
  const { metadata, ...book } = Book;
  _.map(book, (__, element) => {
    try {
      let type = extractBookElementType(element);
      //console.log("type =  " + type);
      type = type.includes("appendix") ? "appendix" : type;
      type = type.includes("section II") ? "section II" : type;
      type = type.includes("section III") ? "section III" : type;

      const BookElement = require("./BookElements/" +
        _.chain(type).camelCase().upperFirst().value()).default;
      elements[type] = BookElement;
    } catch (error) {
      console.error(error);
    }
  });
  //DEBUG: console.log(elements);
  return elements;
}

function extractBookElementType(element) {
  if (element.includes("appendix")) return "appendix";
  //DEBUG:  console.log(element);
  return element.replace(/[^A-Za-z ]/gi, "");
}

const Frame = styled.div`
  max-width: 600px;
  z-index: 1;
`;

const Background = styled.div`
  height: 100vh;
  width: 100%;
  max-width: 768px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  background-color: ${customTheme.global.colors["accent-5"]};
`;

const Container = styled(Box)`
  height: calc(100vh - 70px);
  @media (max-width: 600px) {
    height: calc(100vh - 50px);
  }
`;

function LayoutEngineComponent() {
  return (
    <Container
      fill
      align="center"
      pad="small"
      overflow={{ vertical: "auto", horizontal: "hidden" }}
    >
      <Frame>
        <Background />
        {_.map(Book, (__, element) =>
          layoutEngine.render({
            type: extractBookElementType(element),
            path: ["$", element],
          })
        )}
      </Frame>
    </Container>
  );
}

export default LayoutEngineComponent;



// WEBPACK FOOTER //
// ./src/app/components/LayoutEngine.js